import { IPolygonState, actionTypes } from 'src/ducks/polygon.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getPolygonStatus = (
  state: IPolygonState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
